import { getLocales } from 'assets/locales/Locale';
import { date, defaultDateTimeFormat, defaultServerDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import contractCommentDeleteApi from './delete/Api.ContractComment.Delete';
import contractCommentListApi from './list/Api.ContractComment.List';
import contractCommentSaveApi from './save/Api.ContractComment.Save';

export default class ContractComment
  extends Model<Model.IContractComment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractComment>
{
  id: number;
  comment: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  contractId: number;
  userId: number;
  user: User;

  get createdAtUtcUnix() {
    return date(this.createdAtUtc, defaultServerDateTimeFormat).unix();
  }
  get modifiedAtUtcUnix() {
    return this.modifiedAtUtc ? date(this.modifiedAtUtc, defaultServerDateTimeFormat).unix() : null;
  }

  constructor(
    data: Partial<Model.IContractComment> | Utils.FormData<Model.IContractComment>,
    language?: Locale.Languages
  ) {
    super({ user: User }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    const { lang } = getLocales();
    return {
      id: this.id,
      title: this.user?.displayInfo?.title || lang.unknownUser,
      info: localizeDate(this.createdAtUtc, defaultDateTimeFormat),
      subtitle: this.comment,
      media: this.user?.profilePhoto?.url,
    };
  }
  async save() {
    return await contractCommentSaveApi(this);
  }
  async delete() {
    return await contractCommentDeleteApi({ id: this.id });
  }

  static async list(body?: Api.Core.ContractComment.List.IRequest) {
    const { payload, ...rest } = await contractCommentListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractComment(it)),
        count: payload.count,
      },
    };
  }
}
